import { FC } from "react";
import { Link } from "react-router-dom";
import DbIcon from "designs/DesignB/components/icons";

export interface HeaderFilterProps {
  /** How many vehicles the fleet has; undefined while it loads. */
  count?: number;
}

/**
 * The head of the home page's fleet section (1NOW-11175): eyebrow, the bold title, a line on
 * what the prices mean, and a link to the whole fleet on the Vehicles page.
 */
const HeaderFilter: FC<HeaderFilterProps> = ({ count }) => (
  <div className="mb-6 flex flex-col gap-4 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h2 className="db-title">Featured vehicles</h2>
      <p className="db-sub">Prices shown are daily rates. Add your dates for the exact total.</p>
    </div>
    {typeof count === "number" && count > 0 && (
      <Link to="/vehicles" className="db-sublink self-start sm:self-auto">
        View all {count}
        <DbIcon name="arrowUpRight" />
      </Link>
    )}
  </div>
);

export default HeaderFilter;
